import { render, staticRenderFns } from "./trend_coins.vue?vue&type=template&id=045d1e40&"
import script from "./trend_coins.vue?vue&type=script&lang=js&"
export * from "./trend_coins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports